import {DATE_FORMATS} from "./constants";

export const GenerateFirstOfTheMonth = () => {
	let dateObj = new Date()
	
	let month = dateObj.getMonth()+1
	
	if(month < 10){
		month = '0'+month
	}
	
	let year = dateObj.getFullYear()
	
	return `${year}${month}01`
}

export const GenerateDate = (dateToFormat = null) => {
	let dateObj = new Date()
	
	let day = dateObj.getDate()
	
	if(parseInt(day) < 10){
		day = '0'+day
	}
	
	let month = dateObj.getMonth()+1
	
	if(month < 10){
		month = '0'+month
	}
	
	let year = dateObj.getFullYear()
	
	if(dateToFormat === null){
		return `${year}-${month}-${day}`
	}else{
		return `${month}-${day}-${year}`
	}
}

export const DisplayDate = (date, format=null) => {
	// toHuman is when date string is received frm DB
	// toHuman should only be true when a date is getting displayed
	//  all other times toHuman should be false
	// table format: MM-DD
	// form format: MM-DD-YYYY
	// db format: YYYY-MM-DD
	
	if(!format){return date}
	
	if(date === '' || date === null || date === undefined){
		return ''
	}
	
	let returnFormat
	let year
	let month
	let day = ''
	
	let [first, second, third] = date.split('-')
	
	if(!first || !second){
		return date
	}
	
	if(format !== DATE_FORMATS.db){
		year = first
		month = second
		day = third.split('T')[0]
	}else{
		year = third
		month = first
		day = second
	}
	
	switch(format){
		case DATE_FORMATS.table:
			returnFormat = [second, day, first]
			break
		case DATE_FORMATS.form:
			returnFormat = [second, day, first]
			break
		case DATE_FORMATS.db:
			if(!year){
				year = (new Date()).getFullYear()
			}
			
			returnFormat = [year, month, day]
			break
		default:
			returnFormat = 'Bad Format'
	}
	
	return returnFormat.join('-')
}

export const ToFullSampleTypeName = (typeCode) => {
	switch(typeCode){
		case "solo":
			return "Individual"
		case "bulk":
			return "Bulk/Tank"
		case "herd":
			return "Herd"
		case "comp":
			return "Components"
		default:
			return "Miscellaneous"
	}
}